import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import styled from 'astroturf/react'

import { inviteeCustomFieldsErrorsSelector } from 'selectors'
import { dismissValidationError } from 'actions/errors'
import BookingField from 'components/enter_details/booking_field'
import CustomField from 'components/custom_fields/custom_field'
import _Question from "field-Question.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/custom_fields/field.js?styleId=Question";


const Question = /*#__PURE__*/styled('div', null, {
  displayName: "Question",
  styles: _Question
})

const Field = ({ index, format, name, required, value, answers, includeOther, onChange }) => {
  const dispatch = useDispatch()
  const errors = useSelector(inviteeCustomFieldsErrorsSelector)

  const getError = (errIndex) => {
    if (!errors[errIndex]) return ''
    return errors[errIndex].value?.[0]
  }

  const onFieldChange = useCallback((params) => {
    onChange(index, params)
    dispatch(dismissValidationError('event_fields', index))
  }, [dispatch, index, onChange])

  return (
    <BookingField>
      <Question data-component="question">
        <CustomField
          format={format}
          label={name}
          name={`question_${index}`}
          required={required}
          answerChoices={answers}
          includeOther={includeOther}
          onChange={onFieldChange}
          error={getError(index)}
          value={value}
        />
      </Question>
    </BookingField>
  )
}

export default Field
